export default __webpack_public_path__ + "static/media/Insight200Plus.9546ad04.png";